import React, { useState, createContext, useContext } from "react";

const valorInicial = {
	colunaSelecionada: "",
	usuarioAlteracao: "",
	dataAlteracao: "",
};

const Tabela = createContext();

export const TabelaRedux = ({ children }) => {
	const [tabelaRedux, setTabelaRedux] = useState(valorInicial);

	return (
		<Tabela.Provider
			value={{
				tabelaRedux,
				setTabelaRedux,
			}}
		>
			{children}
		</Tabela.Provider>
	);
};

export const useTabela = () => {
	const context = useContext(Tabela);
	if (!context) {
		throw new Error("useTabela must be used within a TabelaProvider");
	}
	return context;
};

export default Tabela;
